module.exports = __webpack_public_path__ + "img/3-3.c28622a4.svg";